/* eslint-disable react/prop-types */
import Flag from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { token } from '@atlaskit/tokens';
import { FlagComponentProps } from './FlagTypes';

const LinkPersonalMakePrimarySuccessFlag: React.FC<FlagComponentProps> = ({
  onDismiss,
  linkedEmail,
}) => {
  return (
    <Flag
      appearance="normal"
      icon={
        <SuccessIcon
          label="Success"
          primaryColor={token('color.background.success.bold')}
        />
      }
      onDismissed={onDismiss}
      id={'LinkPersonalMakePrimarySuccessFlag'}
      title={'Account added'}
      description={`We've linked ${linkedEmail} and made it your primary account. Log in to link more accounts.`}
      actions={[{ content: 'Log in' }]}
    />
  );
};

export default LinkPersonalMakePrimarySuccessFlag;
